import { render, staticRenderFns } from "./gsgg.vue?vue&type=template&id=399415de&scoped=true&"
import script from "./gsgg.vue?vue&type=script&lang=js&"
export * from "./gsgg.vue?vue&type=script&lang=js&"
import style0 from "./gsgg.vue?vue&type=style&index=0&id=399415de&scoped=true&lang=css&"
import style1 from "./gsgg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399415de",
  null
  
)

export default component.exports